import React from "react";
import { MapRef } from "react-map-gl";
import { StyledButtonLeftHalf, StyledButtonRightHalf, OverlappingElementsContainer } from "./AdditionalActionsStyle";
import { Tooltip } from "@mui/material";
import { MAP_ZOOM_IN, MAP_ZOOM_OUT } from "../../UserVisibleStrings";
import { faMagnifyingGlassMinus, faMagnifyingGlassPlus } from "@fortawesome/sharp-duotone-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type ZoomControlProps = {
    mapRef: React.RefObject<MapRef>,
};

/**
 * ZoomControl component that provides zoom in and zoom out buttons for the map.
 * @param mapRef - Reference to the Map.
 * @returns JSX.Element
 */
export const ZoomControl: React.FC<ZoomControlProps> = ( { mapRef } ) =>
{
    /**
     * Handles zoom actions by dispatching the appropriate action and updating the map view.
     * @param zoomAction - The action for zooming in or out.
     */
    const handleZoom = ( zoomAction: boolean ) =>
    {
        if ( mapRef.current )
        {
            if ( zoomAction )
            {
                mapRef.current.zoomIn();
            }
            else
            {
                mapRef.current.zoomOut();
            }
        }
    };

    return (
        <OverlappingElementsContainer className = "additional-actions">
            <Tooltip title = {MAP_ZOOM_OUT}>
                <StyledButtonLeftHalf onClick = {() => handleZoom( false )}>
                    <FontAwesomeIcon icon = {faMagnifyingGlassMinus} size = "lg" fixedWidth/>
                </StyledButtonLeftHalf>
            </Tooltip>
            <Tooltip title = {MAP_ZOOM_IN}>
                <StyledButtonRightHalf onClick = {() => handleZoom( true )}>
                    <FontAwesomeIcon icon = {faMagnifyingGlassPlus} size = "lg" fixedWidth/>
                </StyledButtonRightHalf>
            </Tooltip>
        </OverlappingElementsContainer>
    );
};
